var _ = require('underscore/underscore.js');

var template = require('./SubmissionFormContributors.jinja');
require('./SubmissionFormContributors.less');

var SubmissionFormContributorsItem = require('submissions/components/SubmissionForm/SubmissionFormContributorsItem');
var SubmissionFormContributorsItemTemplate = require('submissions/components/SubmissionForm/SubmissionFormContributorsItemRuntime.jinja');


var SubmissionFormBlock = require('./SubmissionFormBlock');

module.exports = SubmissionFormBlock.extend({

    template: template,

    events: {
        'click .SubmissionFormContributors-add': 'onAddClick'
    },


    initialize: function (options) {
        this.options = options || {};

        var self = this;

        this.$('.SubmissionFormContributorsItem').each(function () {
            var itemInstance = new SubmissionFormContributorsItem({
                el: this
            });

            self.listenTo(itemInstance, 'delete', self.checkNoEmail);
            self.listenTo(itemInstance, 'invite', self.checkFooterVisibility);

            $(this).data('instance', itemInstance);
        });

        this.checkFooterVisibility();

        SubmissionFormBlock.prototype.initialize.call(this, options);
    },


    deactivate: function (params) {

        this.$('.SubmissionFormContributorsItem').each(function () {
            var itemInstance = $(this).data('instance');

            itemInstance.deactivate();
        });

        return SubmissionFormBlock.prototype.deactivate.call(this, params);
    },


    checkNoEmail: function () {
        var count = this.$('.SubmissionFormContributorsItem').length;

        if (!count) this.onAddClick();
    },


    checkFooterVisibility: function () {
        var count = this.$('.SubmissionFormContributorsItem--empty').length;

        this.$('.SubmissionFormContributors-footer').toggleClass('SubmissionFormContributors-footer--hidden', count > 0);
    },


    onAddClick: function () {
        var $template = $(SubmissionFormContributorsItemTemplate.render({
            email: ''
        }));

        this.$('.SubmissionFormContributors-wrapper').append($template);

        var itemInstance = new SubmissionFormContributorsItem({
            el: $template[0]
        });

        $template.data('instance', itemInstance);

        this.listenTo(itemInstance, 'delete', this.checkNoEmail);
        this.listenTo(itemInstance, 'invite', this.checkFooterVisibility);

        this.checkFooterVisibility();
    },


    checkRequired: function () {
        return true;
    },


    getFormData: function () {
        var contributors = [];

        this.$('.SubmissionFormContributorsItem').each(function (ind) {
            var itemInstance = $(this).data('instance');
            var data = itemInstance.getData();

            if (data.email) {
                contributors.push(data);
            }
        });

        return {
            contributors: contributors
        };
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/submissions/components/SubmissionForm/SubmissionFormContributors.js
// module id = 113
// module chunks = 0